export const startInterval = (callback, ms) => {
    callback();
    return setInterval(callback, ms);
};
//# sourceMappingURL=interval.js.map